export const ROLES = {
    OWNER: 1,
    ADMIN: 2,
    INSTRUCTOR: 3,
    STUDENT: 4,
    GUEST: 0 // Changed from empty string to 0 for consistency with numeric roles
  };
  
  // Get role from sessionStorage
  export const getCurrentRole = () => {
    // Get the full userData object from sessionStorage
    const userDataString = sessionStorage.getItem('userData');
    
    try {
      // Parse the userData if it exists
      const userData = userDataString ? JSON.parse(userDataString) : null;
      
      // Return the roleId if available, otherwise return GUEST
      return userData?.roleId ?? ROLES.GUEST;
    } catch (error) {
      console.error('Error parsing userData:', error);
      return ROLES.GUEST;
    }
  };
  
  export const ROLE_NAMES = {
    [ROLES.OWNER]: "Propietario",
    [ROLES.ADMIN]: "Administrador",
    [ROLES.INSTRUCTOR]: "Instructor",
    [ROLES.STUDENT]: "Estudiante",
    [ROLES.GUEST]: "Invitado"
  };
  
  export const getCurrentRoleName = () => {
    const role = getCurrentRole();
    return ROLE_NAMES[role] || ROLE_NAMES[ROLES.GUEST];
  };
  
  // Role check functions
  export const isGuest = () => {
    const role = getCurrentRole();
    return role === ROLES.GUEST || !sessionStorage.getItem('userRole');
  };
  
  export const isStudent = () => getCurrentRole() === ROLES.STUDENT;
  export const isInstructor = () => getCurrentRole() === ROLES.INSTRUCTOR;
  export const isAdmin = () => getCurrentRole() === ROLES.ADMIN;
  export const isOwner = () => getCurrentRole() === ROLES.OWNER;
  export const isAdminOrOwner = () => [ROLES.ADMIN, ROLES.OWNER].includes(getCurrentRole());
  export const isStaff = () => [ROLES.INSTRUCTOR, ROLES.ADMIN, ROLES.OWNER].includes(getCurrentRole());